/*
 *
 * LanguageProvider constants
 *
 */

export const CHANGE_LOCALE = 'LanguageProvider/CHANGE_LOCALE';
export const UPDATE_LANGUAGE = 'LanguageProvider/UPDATE_LANGUAGE';
export const UPDATE_LANGUAGE_URI = 'LanguageProvider/UPDATE_LANGUAGE_URI';
